import React from 'react';
import { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { Grid } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Multiselect from '../components/Common/UI/Multiselect/Multiselect';
import { useNavigate, useParams } from 'react-router-dom';
import ListContainer from '../components/ListContainer';
import {
  useCreateItemMutation,
  // useDeleteItemMutation,
  useGetItemByIdQuery,
  useUpdateItemMutation,
} from '../slices/simpleApiSlice';
import { REPORTS_SETTINGS_URL } from '../constans';
import Alerton from '../components/Alerton';
import { useDispatch, useSelector } from 'react-redux';
import { setTempReportSettings } from '../slices/authSlice';

const ReportSettingScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: code, settingsId } = useParams();
  const [alertMessage, setAlertMessage] = useState('');
  const [title, setTitle] = useState(``);
  const [allGroups, setAllGroups] = useState([]);
  const [allFilters, setAllFilters] = useState([]);
  const [extraFields, setExtraFields] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedExtraFields, setSelectedExtraFields] = useState([]);
  const [isGlobal, setIsGlobal] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [settings, setSettings] = useState({});
  const tempSettings = useSelector((state) => state.auth.tempReportSettings);

  useEffect(() => {
    if (settingsId === 'new' && tempSettings) {
      // console.log('Found tempSettings[code]', tempSettings[code]);
      if (!tempSettings[code]) return;
      const { title, groupings, filters, extraFields } = tempSettings[code];
      // console.log('tempSettings title', title);
      // console.log('tempSettings groupings', groupings);
      // console.log('tempSettings filters', filters);
      // console.log('tempSettings extraFields', extraFields);
      if (title) setTitle(title);
      if (groupings) setSelectedGroups(groupings);
      if (filters) setSelectedFilters(filters);
      if (extraFields) setSelectedExtraFields(extraFields);
    }
  }, [settingsId, tempSettings]);

  // useEffect(() => {
  //   console.log('settings', settings);
  // }, [settings]);

  const [createItem] = useCreateItemMutation();
  const [updateItem] = useUpdateItemMutation();
  // const [deleteItem] = useDeleteItemMutation();

  const { data, isLoading, isError, error } = useGetItemByIdQuery({
    url: REPORTS_SETTINGS_URL + '/' + settingsId,
    code,
    id: settingsId,
    providesTags: ['ReportSettings'],
    params: { code },
  });

  const setAndRun = () => {
    if (!settings.groupings || settings.groupings.length === 0) {
      setAlertMessage('Выберите хотя бы одну группировку');
      return;
    }
    const payload = {
      code, // "CLI_REVIEW"
      settings: {
        title: title,
        groupings: selectedGroups,
        filters: selectedFilters,
        extraFields: selectedExtraFields,
        isTemp: true,
      },
    };
    // console.log('payload', payload);
    dispatch(setTempReportSettings(payload));
    navigate(`/reports/${code}`);
  };

  const handleFilterChange = (filterId, value) => {
    // setSelectedFilters((prev) => ({ ...prev, [filterId]: value }));

    // Автоматически определяем тип по render.multiple
    const isMultiple = allFilters[filterId]?.render?.multiple ?? false;
    const normalizedValue = isMultiple ? value : value || '';

    console.log(
      'filterId',
      filterId,
      'value',
      value,
      'normalizedValue',
      normalizedValue,
    );

    // setSelectedFilters((prev) => ({
    //   ...prev,
    //   [filterId]: normalizedValue,
    // }));
    setSelectedFilters((prev) => {
      // Если normalizedValue - пустой массив, удаляем ключ
      if (
        isMultiple &&
        Array.isArray(normalizedValue) &&
        normalizedValue.length === 0
      ) {
        const { [filterId]: removed, ...rest } = prev;
        return rest;
      }

      // Если normalizedValue - пустая строка, также удаляем ключ
      if (!isMultiple && normalizedValue === '') {
        const { [filterId]: removed, ...rest } = prev;
        return rest;
      }

      // Иначе обновляем значение
      return {
        ...prev,
        [filterId]: normalizedValue,
      };
    });
  };

  // Для Multiselect (groupings) — предполагаем value = {type, value}
  const handleGroupsChange = (newSelected) => setSelectedGroups(newSelected);
  const handleExtraFieldsChange = (newSelected) =>
    setSelectedExtraFields(newSelected);

  const handleCreateUpdate = async () => {
    if (!settings.groupings || settings.groupings.length === 0) {
      setAlertMessage('Выберите хотя бы одну группировку');
      return;
    }

    const payload = { ...settings, id: settingsId, url: REPORTS_SETTINGS_URL };

    console.log('payload', payload);

    let result;
    try {
      if (settingsId === 'new') {
        result = await createItem(payload).unwrap();
        navigate(`/reports/${code}/${result._id || result.id}`);
      } else {
        result = await updateItem(payload).unwrap();
        console.log('result', result);
      }
    } catch (error) {
      console.log('error', error);

      setAlertMessage(
        error?.data?.message || error?.error || error?.massage || error,
      );
    }
  };

  useEffect(() => {
    //Надо для каждого объекта из массива data?.item.groupings
    //найти в массиве data.allGroups элемент с такими же значениями type и value
    //и записать title из его в settings.groupings

    if (settingsId !== 'new') {
      const updatedGroupings =
        data?.item?.groupings?.map((grouping) => {
          const foundGroup = data?.allGroups?.find(
            (g) => g.type === grouping.type && g.value === grouping.value,
          );
          return {
            type: grouping.type,
            value: grouping.value,
            title: foundGroup?.title || '',
          };
        }) || [];
      const transformedSelectedExtraFields =
        data?.item?.extraFields?.map((field) => {
          return {
            type: field.path,
            value: field.path,
            title: field.title,
          };
        }) || [];

      setTitle(data?.item?.title || '');

      setSelectedGroups(updatedGroupings);
      setSelectedFilters(data?.item?.filters || {});
      setSelectedExtraFields(transformedSelectedExtraFields);
    }
    if (data?.item?.isGlobal !== undefined) {
      setIsDefault(data?.item?.isGlobal);
    }
    if (data?.item?.isDefault !== undefined) {
      setIsDefault(data?.item?.isDefault);
    }

    if (data?.allGroups) setAllGroups(data.allGroups);
    if (data?.allFilters) setAllFilters(data.allFilters);

    const updatedExtraFields =
      data?.extraFields?.map((field) => {
        return {
          type: field.path,
          value: field.path,
          title: field.title,
        };
      }) || [];
    setExtraFields(updatedExtraFields);
  }, [data, settingsId]);

  useEffect(() => {
    //генерируем вот такой объект
    // {
    // code: 'ACQ_CLI',
    // title: 'Месяц + источник',
    // groupings: [
    // 	{ type: 'period', value: 'month' },
    // 	{ type: 'field', value: 'leadSource' }
    // ],
    // filters: {
    // 	types: ['507f1f77bcf86cd799439011']
    // },
    // isGlobal: true,
    // extraFields": [
    //   {
    //     "path": "type.title",
    //     "label": "Тип объекта"
    //   },
    //   {
    //     "path": "kadastr",
    //     "label": "Кадастр"
    //   }
    // ]

    const extraFields = selectedExtraFields.map(({ type, title }) => ({
      path: type,
      title,
    }));

    const generatedGroupings = selectedGroups.map(({ type, value }) => ({
      type,
      value,
    }));
    const generatedFilters = { ...selectedFilters }; // Уже готовый объект

    const newSettings = {
      code,
      title,
      groupings: generatedGroupings,
      filters: generatedFilters,
      extraFields,
      isGlobal,
      isDefault,
    };
    setSettings(newSettings); // Для отладки в консоли
    // console.log('Generated settings:', newSettings); // ✅ Отладка в реалтайм
  }, [
    title,
    selectedGroups,
    selectedFilters,
    isGlobal,
    code,
    isDefault,
    selectedExtraFields,
  ]);

  const goBack = () => {
    navigate(`/reports/${code}`);
  };

  if (isLoading) {
    return <CircularProgress />;
  } else if (isError) {
    return (
      <Alert severity='error'>
        {error.data.message ||
          error.error ||
          error.message ||
          error ||
          'Что-то пошло не так'}
      </Alert>
    );
  }

  return (
    <>
      <ListContainer goBack={goBack} title={'Настройка отчета'}>
        <TextField
          size='small'
          fullWidth
          value={title}
          id='outlined-basic'
          label='Название настройки'
          onChange={(e) => setTitle(e.target.value)}
        />
        <Grid item xs={12} sx={{ mt: 1 }}>
          <strong>Основная настройка</strong>
          <Switch
            onChange={(e) => setIsDefault(e.target.checked)}
            checked={isDefault}
          />
        </Grid>

        <Box
          sx={{
            width: '100%',
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            p: 2,
            mt: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
            <Typography variant='h6' sx={{ flexGrow: 1 }}>
              Фильтры:
            </Typography>
          </Box>

          {allFilters &&
            Object.entries(allFilters)
              .sort(
                ([aId, aCfg], [bId, bCfg]) =>
                  (aCfg.sort ?? 0) - (bCfg.sort ?? 0),
              )
              .map(([filterId, cfg]) => {
                return (
                  <Box key={filterId} sx={{ mt: 1 }}>
                    <Filter
                      filterId={filterId}
                      item={cfg}
                      selectedFilters={selectedFilters}
                      handleFilterChange={handleFilterChange}
                    />
                  </Box>
                );
              })}
        </Box>

        {allGroups && (
          <Multiselect
            title='Группировки'
            emptyMessage='Группировки не выбраны'
            allItems={allGroups}
            selectedItems={selectedGroups}
            setSelectedItems={handleGroupsChange}
          />
        )}

        {extraFields && (
          <Multiselect
            title='Дополнительные поля'
            emptyMessage='Дополнительные поля не выбраны'
            allItems={extraFields}
            selectedItems={selectedExtraFields}
            setSelectedItems={handleExtraFieldsChange}
          />
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 1,
            gap: 1,
          }}
        >
          <Button variant='contained' onClick={handleCreateUpdate}>
            Сохранить
          </Button>
          <Button variant='contained' onClick={setAndRun}>
            Сформировать
          </Button>
          {/* <Grid item xs={12}>
            <strong>Доступна всем</strong>
            <Switch
              onChange={(e) => setIsGlobal(e.target.checked)}
              checked={isGlobal}
            />
          </Grid> */}
        </Box>
      </ListContainer>
      <Alerton
        message={alertMessage}
        handleCloseMessage={() => setAlertMessage('')}
      />
    </>
  );
};

export default ReportSettingScreen;

const Filter = ({ filterId, item, selectedFilters, handleFilterChange }) => {
  const { options, render } = item;
  const { component, title, multiple } = render;

  if (component === 'checkbox') {
    return (
      <Grid item xs={12}>
        <strong>{title}</strong>
        <Switch
          onChange={(e) => handleFilterChange(filterId, e.target.checked)}
          checked={!!selectedFilters[filterId]}
        />
      </Grid>
    );
  }

  if (component === 'select' && options?.length) {
    return (
      <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
        <Grid item sm={11} md={11} xs={11}>
          <FormControl fullWidth size='small'>
            <InputLabel id={`${filterId}-multiple-checkbox-label`}>
              {title}
            </InputLabel>
            <Select
              labelId={`${filterId}-label`}
              multiple={multiple}
              value={selectedFilters[filterId] || (multiple ? [] : '')}
              onChange={(e) => handleFilterChange(filterId, e.target.value)}
              input={<OutlinedInput label={title} />}
              renderValue={(selected) => {
                const values = Array.isArray(selected)
                  ? selected
                  : selected
                    ? [selected]
                    : [];
                return values.length ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {values.map((id) => {
                      const opt = options.find((o) => o._id === id);
                      return (
                        <Chip key={id} label={opt?.label || id} size='small' />
                      );
                    })}
                  </Box>
                ) : (
                  <em>Выберите...</em>
                );
              }}
            >
              {options.map((opt) => (
                <MenuItem key={opt._id} value={opt._id}>
                  {multiple && (
                    <Checkbox
                      checked={
                        selectedFilters[filterId]?.includes?.(opt._id) ?? false
                      }
                    />
                  )}
                  <ListItemText primary={opt.label} />
                </MenuItem>
              ))}
            </Select>

            {/* <Select
              labelId={`${filterId}-multiple-checkbox-label`}
              multiple={multiple}
              value={selectedFilters[filterId] || []}
              onChange={(e) => handleFilterChange(filterId, e.target.value)}
              input={<OutlinedInput label={title} />}
              renderValue={(selected) => {
                console.log('selected', selected);

                return (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((id) => {
                      const opt = options.find((o) => o._id === id);
                      return (
                        <Chip key={id} label={opt?.label || id} size='small' />
                      );
                    })}
                  </Box>
                );
              }}
            >
              {options.map((opt) => (
                <MenuItem key={opt._id} value={opt._id}>
                  {multiple && (
                    <Checkbox
                      checked={
                        selectedFilters[filterId]?.includes(opt._id) ?? false
                      }
                    />
                  )}
                  <ListItemText primary={opt.label} />
                </MenuItem>
              ))}
            </Select> */}
            {/* Логика: value — массив _id, renderValue показывает label по ID,
            Checkbox проверяет наличие ID. */}
          </FormControl>
        </Grid>
        <Grid item sm={1} md={1} xs={1}>
          <IconButton
            size='small'
            onClick={() => handleFilterChange(filterId, multiple ? [] : '')}
            disabled={!selectedFilters[filterId]?.length}
          >
            <ClearIcon fontSize='small' />
          </IconButton>
        </Grid>
      </Grid>
    );
  }
};
